<template>
  <div>
    <audio :id="'vm-audio-' + dirFolder" style="display: none" src=""></audio>

    <vm-current-greeting
      v-if="greetingRecord"
      :name="defaultName"
      :record="greetingRecord"
      :isPlaying="greetingIsPlaying"
      :removeProcessing="removeProcessing"
      @play="play"
      @pause="pause"
      @remove="removeGreeting"
    />

    <h4 class="black-text mb-5">Select greeting</h4>
    <div class="inline-form-group">
      <el-radio-group v-model="choice" class="mt-5">
        <el-radio class="black-text" label="existing">From media file</el-radio>
        <el-radio class="black-text" label="custom">Record or Upload</el-radio>
      </el-radio-group>
    </div>

    <vm-mediafile
      v-show="choice === 'existing'"
      :mediafileOptions="mediafileOptions"
      :isPlaying="choiceIsPlaying"
      :saveProcessing="saveProcessing"
      :saveSucceded="saveSucceded"
      @play="play"
      @pause="pause"
      @save="saveGreeting"
    />

    <vm-record-or-upload
      v-show="choice === 'custom'"
      :isPlaying="choiceIsPlaying"
      :recordedName="recordedName"
      :saveProcessing="saveProcessing"
      :saveSucceded="saveSucceded"
      @play="play"
      @pause="pause"
      @save="saveGreeting"
    />
  </div>
</template>

<script>
import feathersClient, { hostServer } from "@/feathers/feathers-client";

import VmCurrentGreeting from "./vmCurrentGreeting.vue";
import VmMediafile from "./vmMediafile.vue";
import VmRecordOrUpload from "./vmRecordOrUpload.vue";

export default {
  name: "VmNameGreeting",

  props: {
    mailboxuser: { required: true },
    mailboxContext: { required: true },
    currentGreeting: { default: null },
    defaultName: { required: true },
    recordedName: { required: true },
    dirFolder: { required: true },
    mediafileOptions: { required: true },
  },

  components: {
    VmCurrentGreeting,
    VmMediafile,
    VmRecordOrUpload,
  },

  data() {
    return {
      greetingIsPlaying: false,
      audioEl: null,
      greetingRecord: null,
      removeProcessing: false,
      saveProcessing: false,
      saveSucceded: false,

      choice: "existing",
      choiceIsPlaying: false,

      audioType: null,
    };
  },

  watch: {
    currentGreeting(currentGreeting) {
      this.greetingRecord = currentGreeting;
    },

    choice() {
      if (this.audioType !== "greeting") {
        this.pause();
      }
    },

    saveSucceded(saveSucceded) {
      if (saveSucceded) {
        this.choice = "existing";
      }
    },
  },

  methods: {
    // ⭐️ Greeting ⭐️ //
    play({ blob, type }) {
      this.pause();

      // type === 'greeting' || 'choice'
      this.audioType = type;
      this.audioEl.src = blob;
      this[`${type}IsPlaying`] = true;
      this.audioEl.play();
    },

    pause() {
      this.greetingIsPlaying = false;
      this.choiceIsPlaying = false;
      this.audioEl.pause();
      this.audioEl.currentTime = 0;
    },

    removeGreeting(id) {
      this.pause();
      this.removeProcessing = true;
      feathersClient
        .service("voicemail-messages")
        .remove(id, {
          query: {
            mailboxuser: this.mailboxuser,
            mailboxContext: this.mailboxContext,
          },
        })
        .then(() => {
          this.greetingRecord = null;
          this.$emit("greetingRemoved");
          this.$notify({
            type: "success",
            title: "Success",
            message: "Greeting removed successfully!",
          });
          this.removeProcessing = false;
        })
        .catch(() => {
          this.removeProcessing = false;
        });
    },

    saveGreeting(data) {
      this.saveProcessing = true;
      this.saveSucceded = false;

      let formData = new FormData();
      formData.append("type", "vmGreeting");
      formData.append("mailboxuser", this.mailboxuser);
      formData.append("mailboxContext", this.mailboxContext);
      formData.append("greetingTypes", [this.dirFolder]);

      const { type, file, meId } = data;

      if (type === "existing") {
        formData.append("meId", meId);
      }

      if (type === "custom") {
        formData.append("vmFile", file);
      }

      fetch(`${hostServer}/voicemail-messages`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${this.$store.state.auth.accessToken}`,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          this.saveProcessing = false;
          this.greetingRecord = res[0];
          this.saveSucceded = true;
          this.$emit("greetingSaved", res[0]);

          this.$notify({
            type: "success",
            title: "Greeting Uploaded",
            message: "Your greeting was successfully uploaded and applied.",
          });
        })
        .catch(() => {
          this.saveProcessing = false;
        });
    },
  },

  mounted() {
    this.audioEl = document.getElementById(`vm-audio-${this.dirFolder}`);
    this.audioEl.addEventListener("ended", () => {
      if (this.audioType) {
        this[`${this.audioType}IsPlaying`] = false;
      }
    });
  },

  beforeDestroy() {
    this.audioEl.removeEventListener("ended", () => true);
  },
};
</script>
